/* eslint-disable jsx-a11y/heading-has-content */
import React from "react";
import { styles } from "./styles";
import theme from "@/constants/theme";
import { MarkdownReader } from "@/components/dataDisplay/MarkdownReader";

interface Props {
  content?: string;
}

export const Reading: React.FC<Props> = ({ content }) => {
  if (!content) {
    return (
      <p style={{ color: theme.colors.text.default }}>
        No hay contenido por mostrar.
      </p>
    );
  }
  return (
    <div style={styles.contentContainer}>
      <MarkdownReader>{content}</MarkdownReader>
    </div>
  );
};
